import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { slugify } from '../../utils';

const GlossaryTerm = ({ term: { title, emboldenTitle = 'true' }, description, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleClasses = classNames('toggle-info', {
    'toggle-info--show': isOpen
  });

  return (
    <div
      key={slugify(title)}
      className={className}
      onClick={() => setIsOpen(!isOpen)}
      role="button"
      tabIndex="0"
      onKeyUp={(e) => (e.key === 'Enter' ? setIsOpen(!isOpen) : null)}
    >
      <p className="blog-toggle-title">
        <span className="moreless">{isOpen ? '-' : '+'}</span>
        {emboldenTitle === 'true' ? <b>{title}</b> : title}
      </p>
      <div className={toggleClasses} dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

const stripParagraphs = (text) => text.replace(/^<p>/, '').replace(/<\/p>\s*$/, '');

const Glossary = (props) => {
  const { title, intro, textColour, terms, colourScheme, customPadding, alignment } = props;

  const componentClasses = classNames('glossary-container', {
    [`glossary-container--${colourScheme}-scheme`]: colourScheme,
    [`glossary-container--text-${textColour}`]: textColour,
    'glossary-container--no-padding-top-bottom': customPadding === 'no-padding'
  });

  const toggleClasses = classNames('toggle-block', {
    [`toggle-block--align-${alignment}`]: alignment
  });

  return (
    <section className="glossary-section">
      <div className={componentClasses}>
        {title && <h3>{title}</h3>}
        {intro && <p dangerouslySetInnerHTML={{ __html: stripParagraphs(intro) }} />}
        {terms
          ? terms.map((term) => (
              <GlossaryTerm className={toggleClasses} key={term.title} term={term} description={props[term.src]} />
            ))
          : null}
      </div>
    </section>
  );
};
Glossary.propTypes = {
  customPadding: PropTypes.oneOf(['no-padding']),
  alignment: PropTypes.oneOf(['center']),
  title: PropTypes.string,
  intro: PropTypes.string,
  textColour: PropTypes.oneOf(['dark-navy']),
  terms: PropTypes.array,
  colourScheme: PropTypes.oneOf(['grey', 'dark-navy', 'light-grey'])
};
export default Glossary;
